import React, { useEffect, useState } from "react";
import {
    CFormGroup,
    CLabel,
    CInput,
    CCard,
    CCardBody,
    CButton,
    CTabs,
    CNav,
    CNavItem,
    CNavLink,
    CTabContent,
    CTabPane,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import Form, { FormApi } from "../../../components/form";
import useCustomForm from "../../../services/useCustomForm";
import Select from "react-select";
import { getApi } from "../../../apis/backendApis";
import useAlert from "../../../services/useAlert";

interface RelatorioRetrospectivaFormData {
    titulo: string;
    dataInfos: {
        versao: { idSprint: number; sprintName: string }[];
        data_prevista: string;
        data_efetiva: string;
        problemas: string[] | null;
        destaques: string[] | null;
        discussoes: { contexto: string; pergunta: string }[];
        conquistas: {
            titulo: string;
            master: boolean;
            icon: string;
        }[];
    }[];
}

const RelatorioRetrospectivaForm = () => {
    const [formApi, setFormApi] = useState<FormApi>();
    const [listSprints, setListSprints] = useState<any[]>([]);
    const [showAlert] = useAlert();

    const initialValues: RelatorioRetrospectivaFormData = {
        titulo: '',
        dataInfos: [
            {
                versao: [{ idSprint: 0, sprintName: "" }],
                data_prevista: "",
                data_efetiva: "",
                problemas: [""],
                destaques: [""],
                discussoes: [{ contexto: "", pergunta: "" }],
                conquistas: [],
            },
        ],
    };

    const { values, setValues, handleChange, handleSubmit, handleSubmitValues } =
        useCustomForm({
            initialValues,
            route: "relatorio-retrospectiva",
            onSubmit: (values) => {
                handleSubmitValues(values.values);
            },
        });

    useEffect(() => {
        getListSprints();
    }, []);

    const getListSprints = () => {
        let api = getApi();
        api.get(`get/list/sprints`).then((response) => {
            setListSprints(response.data);
        });
    };

    const handleOptionSprint = (optionSprint: any, index: number) => {
        let idSprint = optionSprint.value;
        let sprintName = optionSprint.label;
        const newInfos = [...values.dataInfos];
        newInfos[index].versao[0].idSprint = idSprint;
        newInfos[index].versao[0].sprintName = sprintName;
        setValues({ ...values, dataInfos: newInfos });
    };

    const handleFormReady = (formApi: FormApi) => {
        setFormApi(formApi);
    };

    const addConquista = () => {
        const newInfos = [...values.dataInfos];
        newInfos[0].conquistas.push({ titulo: "", master: false, icon: "" });
        setValues({ ...values, dataInfos: newInfos });
    };

    const removeConquista = (cIndex: number) => {
        const newInfos = [...values.dataInfos];
        newInfos[0].conquistas.splice(cIndex, 1);
        setValues({ ...values, dataInfos: newInfos });
    };

    const addProblema = (sIndex: number) => {
        const newInfos = [...values.dataInfos];
        newInfos[sIndex].problemas.push("");
        setValues({ ...values, dataInfos: newInfos });
    };

    const removeProblema = (sIndex: number, pIndex: number) => {
        const newInfos = [...values.dataInfos];
        newInfos[sIndex].problemas.splice(pIndex, 1);
        setValues({ ...values, dataInfos: newInfos });
    };

    const addDestaque = (sIndex: number) => {
        const newInfos = [...values.dataInfos];
        newInfos[sIndex].destaques.push("");
        setValues({ ...values, dataInfos: newInfos });
    };

    const removeDestaque = (sIndex: number, dIndex: number) => {
        const newInfos = [...values.dataInfos];
        newInfos[sIndex].destaques.splice(dIndex, 1);
        setValues({ ...values, dataInfos: newInfos });
    };

    const addDiscussao = (sIndex: number) => {
        const newInfos = [...values.dataInfos];
        newInfos[sIndex].discussoes.push({ contexto: "", pergunta: "" });
        setValues({ ...values, dataInfos: newInfos });
    };

    const removeDiscussao = (sIndex: number, dIndex: number) => {
        const newInfos = [...values.dataInfos];
        newInfos[sIndex].discussoes.splice(dIndex, 1);
        setValues({ ...values, dataInfos: newInfos });
    };

    const addSprint = () => {
        if (values.dataInfos.length <= 1) {
            setValues({
                ...values,
                dataInfos: [
                    ...values.dataInfos,
                    {
                        versao: [{ idSprint: 0, sprintName: "" }],
                        data_prevista: "",
                        data_efetiva: "",
                        problemas: [""],
                        destaques: [""],
                        discussoes: [{ contexto: "", pergunta: "" }],
                        conquistas: [],
                    },
                ],
            });
        } else {
            showAlert({
                title: "Limite de Sprints excedido",
                // @ts-ignore
                msg: "Somente duas sprints por relatório",
                toaster: false,
            });
        }
    };

    const removeSprint = (sIndex: number) => {
        const newInfos = [...values.dataInfos];
        newInfos.splice(sIndex, 1);
        setValues({ ...values, dataInfos: newInfos });
    };

    return (
        <Form entity="Relatório Retrospectiva" handleSubmit={handleSubmit} onFormReady={handleFormReady}>
            <CFormGroup>
                <label>Titulo Relatório</label>
                <CInput type="text" id="titulo" name="titulo" value={values.titulo} onChange={handleChange}/>
            </CFormGroup>
            {values?.dataInfos?.map((sprint: any, sIndex: number) => (
                <div key={sIndex} className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="mb-0">Sprint {sIndex + 1}</h5>
                        <div>
                            <CButton
                                color="danger"
                                size="sm"
                                onClick={() => removeSprint(sIndex)}
                                disabled={values.dataInfos.length === 1}
                            >
                                <CIcon name="cil-trash" className="mr-1" />
                                Remover Sprint
                            </CButton>
                        </div>
                    </div>
                    <CTabs>
                        <CNav variant="tabs">
                            <CNavItem>
                                <CNavLink>Geral</CNavLink>
                            </CNavItem>
                            <CNavItem>
                                <CNavLink>Problemas</CNavLink>
                            </CNavItem>
                            <CNavItem>
                                <CNavLink>Destaques</CNavLink>
                            </CNavItem>
                            <CNavItem>
                                <CNavLink>Discussões</CNavLink>
                            </CNavItem>
                        </CNav>

                        <CTabContent>
                            <CTabPane>
                                <CCard>
                                    <CCardBody>
                                        <CFormGroup>
                                            <CLabel>Versão / Sprint</CLabel>
                                            <Select
                                                name="versao"
                                                options={listSprints}
                                                value={listSprints.find(
                                                    (s) => s.value === sprint.versao[0].idSprint
                                                )}
                                                onChange={(opt) => handleOptionSprint(opt, sIndex)}
                                                placeholder="Selecione a Sprint"
                                            />
                                        </CFormGroup>
                                        <CFormGroup>
                                            <CLabel>Data Prevista</CLabel>
                                            <CInput
                                                required={true}
                                                type="date"
                                                name="data_prevista"
                                                value={sprint.data_prevista}
                                                onChange={(e) =>
                                                    handleChange(e, sIndex, "dataInfos")
                                                }
                                            />
                                        </CFormGroup>
                                        <CFormGroup>
                                            <CLabel>Data Efetiva</CLabel>
                                            <CInput
                                                required={true}
                                                type="date"
                                                name="data_efetiva"
                                                value={sprint.data_efetiva}
                                                onChange={(e) =>
                                                    handleChange(e, sIndex, "dataInfos")
                                                }
                                            />
                                        </CFormGroup>
                                    </CCardBody>
                                </CCard>
                            </CTabPane>

                            <CTabPane>
                                {sprint.problemas.map((prob: any, pIndex: any) => (
                                    <CCard key={pIndex}>
                                        <CCardBody>
                                            <CFormGroup>
                                                <CLabel>Problema</CLabel>
                                                <CInput
                                                    type="text"
                                                    value={prob}
                                                    onChange={(e) => {
                                                        const newInfos = [...values.dataInfos];
                                                        newInfos[sIndex].problemas[pIndex] =
                                                            // @ts-ignore
                                                            e.target.value;
                                                        setValues({ ...values, dataInfos: newInfos });
                                                    }}
                                                />
                                            </CFormGroup>
                                            <CFormGroup row className="justify-content-end">
                                                <CButton
                                                    size="sm"
                                                    onClick={() => addProblema(sIndex)}
                                                >
                                                    <CIcon name="cil-plus" />
                                                </CButton>
                                                <CButton
                                                    size="sm"
                                                    onClick={() => removeProblema(sIndex, pIndex)}
                                                >
                                                    <CIcon name="cil-minus" />
                                                </CButton>
                                            </CFormGroup>
                                        </CCardBody>
                                    </CCard>
                                ))}
                            </CTabPane>

                            <CTabPane>
                                {sprint.destaques.map((dest: any, dIndex: any) => (
                                    <CCard key={dIndex}>
                                        <CCardBody>
                                            <CFormGroup>
                                                <CLabel>Destaque</CLabel>
                                                <CInput
                                                    type="text"
                                                    value={dest}
                                                    onChange={(e) => {
                                                        const newInfos = [...values.dataInfos];
                                                        newInfos[sIndex].destaques[dIndex] =
                                                            // @ts-ignore
                                                            e.target.value;
                                                        setValues({ ...values, dataInfos: newInfos });
                                                    }}
                                                />
                                            </CFormGroup>
                                            <CFormGroup row className="justify-content-end">
                                                <CButton
                                                    size="sm"
                                                    onClick={() => addDestaque(sIndex)}
                                                >
                                                    <CIcon name="cil-plus" />
                                                </CButton>
                                                <CButton
                                                    size="sm"
                                                    onClick={() =>
                                                        removeDestaque(sIndex, dIndex)
                                                    }
                                                >
                                                    <CIcon name="cil-minus" />
                                                </CButton>
                                            </CFormGroup>
                                        </CCardBody>
                                    </CCard>
                                ))}
                            </CTabPane>

                            <CTabPane>
                                {sprint.discussoes.map((disc: any, dIndex: any) => (
                                    <CCard key={dIndex}>
                                        <CCardBody>
                                            <CFormGroup>
                                                <CLabel>Contexto</CLabel>
                                                <CInput
                                                    type="text"
                                                    value={disc.contexto}
                                                    onChange={(e) => {
                                                        const newInfos = [...values.dataInfos];
                                                        newInfos[sIndex].discussoes[dIndex].contexto =
                                                            // @ts-ignore
                                                            e.target.value;
                                                        setValues({ ...values, dataInfos: newInfos });
                                                    }}
                                                />
                                            </CFormGroup>
                                            <CFormGroup>
                                                <CLabel>Pergunta</CLabel>
                                                <CInput
                                                    type="text"
                                                    value={disc.pergunta}
                                                    onChange={(e) => {
                                                        const newInfos = [...values.dataInfos];
                                                        newInfos[sIndex].discussoes[dIndex].pergunta =
                                                            // @ts-ignore
                                                            e.target.value;
                                                        setValues({ ...values, dataInfos: newInfos });
                                                    }}
                                                />
                                            </CFormGroup>
                                            <CFormGroup row className="justify-content-end">
                                                <CButton
                                                    size="sm"
                                                    onClick={() => addDiscussao(sIndex)}
                                                >
                                                    <CIcon name="cil-plus" />
                                                </CButton>
                                                <CButton
                                                    size="sm"
                                                    onClick={() =>
                                                        removeDiscussao(sIndex, dIndex)
                                                    }
                                                >
                                                    <CIcon name="cil-minus" />
                                                </CButton>
                                            </CFormGroup>
                                        </CCardBody>
                                    </CCard>
                                ))}
                            </CTabPane>
                        </CTabContent>
                    </CTabs>
                </div>
            ))}

            <CButton color="primary" className="mt-3" onClick={addSprint}>
                <CIcon name="cil-plus" className="mr-1" />
                Adicionar Sprint
            </CButton>

            <div className="mb-4 mt-5">
                <h5>Principais Conquistas</h5>
                {values?.dataInfos?.[0]?.conquistas?.map((c: any, cIndex: any) => (
                    <CCard key={cIndex}>
                        <CCardBody>
                            <CFormGroup>
                                <div className="form-check">
                                    <input className="form-check-input"
                                           type="checkbox"
                                           checked={c.master}
                                           onChange={(e) => {
                                               const newInfos = [...values.dataInfos];
                                               //@ts-ignore
                                               newInfos[0].conquistas[cIndex].master = e.target.checked;
                                               newInfos[0].conquistas[cIndex].icon = "";
                                               newInfos[0].conquistas[cIndex].titulo = "";
                                               setValues({...values, dataInfos: newInfos});
                                           }}/>
                                    <label className="form-check-label">
                                        Master?
                                    </label>
                                </div>
                            </CFormGroup>
                            <CFormGroup>
                                <div className={'mb-2'}>
                                    {!c.master && (
                                        <>
                                            <CLabel>Título da Conquista</CLabel>
                                            <CInput
                                                type="text"
                                                value={c.titulo}
                                                onChange={(e) => {
                                                    const newInfos = [...values.dataInfos];
                                                    // @ts-ignore
                                                    newInfos[0].conquistas[cIndex].titulo = e.target.value;
                                                    setValues({...values, dataInfos: newInfos});
                                                }}
                                            />
                                        </>
                                    )}
                                </div>
                                <div className={'mb-2'}>
                                    <CLabel>Resumo Conquista</CLabel>
                                    <CInput
                                        type="text"
                                        value={c.resumo}
                                        onChange={(e) => {
                                            const newInfos = [...values.dataInfos];
                                            // @ts-ignore
                                            newInfos[0].conquistas[cIndex].resumo = e.target.value;
                                            setValues({...values, dataInfos: newInfos});
                                        }}
                                    />
                                </div>
                            </CFormGroup>

                            {!c.master && (
                                <CFormGroup>
                                    <div>
                                        <CLabel className={'mr-2'}>
                                            Ícone
                                        </CLabel>
                                        <CIcon name={values?.dataInfos?.[0]?.conquistas?.[cIndex]?.icon || ""}/>
                                    </div>
                                    <Select
                                        options={[
                                            {value: "cil-code", label: "Code"},
                                            {value: "cil-graph", label: "Graph"},
                                            {value: "cil-people", label: "People"},
                                            {value: "cil-check-circle", label: "Check"},
                                        ]}
                                        value={{
                                            value: c.icon,
                                            label: c.icon,
                                        }}
                                        onChange={(opt) => {
                                            const newInfos = [...values.dataInfos];
                                            newInfos[0].conquistas[cIndex].icon = opt?.value || "";
                                            setValues({...values, dataInfos: newInfos});
                                        }}
                                    />

                                </CFormGroup>
                            )}

                            <CFormGroup row className="justify-content-end">
                                <CButton size="sm" onClick={addConquista}>
                                    <CIcon name="cil-plus"/>
                                </CButton>
                                <CButton size="sm" onClick={() => removeConquista(cIndex)}>
                                    <CIcon name="cil-minus"/>
                                </CButton>
                            </CFormGroup>
                        </CCardBody>
                    </CCard>
                ))}

                {values?.dataInfos?.[0]?.conquistas?.length === 0 && (
                    <CButton size="sm" color="primary" onClick={addConquista}>
                        <CIcon name="cil-plus" className="mr-1" />
                        Adicionar Conquista
                    </CButton>
                )}
            </div>


        </Form>
    );
};

export default RelatorioRetrospectivaForm;
